// extracted by mini-css-extract-plugin
export var actions = "_1k-0";
export var actionsContainer = "_1k-6";
export var border = "_1k-1";
export var childFullHeight = "_1k-d";
export var collapse = "_1k-2";
export var content = "_1k-8";
export var contentChild = "_1k-c";
export var fullscreen = "_1k-a";
export var hasLeftRadius = "_1k-i";
export var headerContainer = "_1k-3";
export var headerRow = "_1k-5";
export var hidePadding = "_1k-9";
export var navCollapsedGap = "_1k-j";
export var noScrollX = "_1k-k";
export var noScrollY = "_1k-l";
export var noTopPadding = "_1k-g";
export var optOutTopPadding = "_1k-b";
export var pageMain = "_1k-h";
export var pageOuter = "_1k-e";
export var pagePadding = "_1k-7";
export var profile = "_1k-m";
export var profileContainer = "_1k-n";
export var profileImage = "_1k-o";
export var profileMain = "_1k-p";
export var profileSubtitle = "_1k-r";
export var profileTitle = "_1k-q";
export var showLeftPadding = "_1k-f";
export var tabsWrapper = "_1k-4";
export var title = "_1k-s";